import getClient from '../utils/client';

type createCasePayload = {
    "title":string,
    "channelCode":string,
    "contactRengaId": string,
    "agentLdap":string,
    "productCode":string,
    "productFamilyCode":string,
    "issueType":string,
    "level1Code":string,
    "conversationId":string
  }

export default async function createC1Case(payload: createCasePayload): Promise<any> {
  return getClient()
    .post(`/api/v1/cases/create`, payload)
    .then(res => {
      const receivedRes = res.data ? res.data : {};
      console.log('oc-ccm-module, createCaseResponse :', JSON.stringify(receivedRes));
      return receivedRes;
    })
    .catch(e => {
      console.log('oc-ccm-module, createCaseResponse : Exception Occured', e);
      return {};
    });
}
